import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(14 * 3600 + 32 * 60 + 18);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-95" data-mp="20rjxg2c1lex7">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-96" data-mp="3h63amgplf4s5">
        <div className="mx-auto max-w-4xl text-center" data-id="element-97" data-mp="3c8jx5j0pyw19">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-98" data-mp="3c7s3idqon8dm">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-99" data-mp="4t5mjfll1dzm">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-100" data-mp="erlefksfora6" data-mpi={index}>
                <div data-id="element-101" data-mp="eqtkeeehj1m0">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-102" data-mp="eoz8tqp3slul">
                    {value}
                  </p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-103" data-mp="3i790yct0w45z">{label}</p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-104" data-mp="3n5u1yeg3mrvh">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-105" data-mp="2ugdbvnfybn2f">
            Después sube. <b className="text-white" data-id="element-106" data-mp="2zgivqhfzc59y">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-107" data-mp="2rguxj7e7tkak">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-108" data-mp="2mibf3gytyqmy">
              <span data-id="element-109" data-mp="316ekop8yo0b8">Cupos al precio de lanzamiento</span>
              <span data-id="element-110" data-mp="3164q0ocz14z7">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-111" data-mp="2w71ohdw79gvz">
              <div className="h-full w-[73%] rounded-full bg-red-500" data-id="element-112" data-mp="28hqtye5g0iqa" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-113" data-mp="23ixewhaicjo0">
              73% de los cupos ya tomados
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-16 sm:py-24" data-id="element-114" data-mp="2ihrf85mvh8x4">
        <div className="mx-auto max-w-2xl" data-id="element-115" data-mp="2dhd6smhczwyk">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-116" data-mp="2dgajeoj8wcne">
            TU PROTOCOLO COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-117" data-mp="3tx6czbmwo4ta">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-118" data-mp="57drf2fx8yan">
              <div data-id="element-119" data-mp="3ngo4uu5os4zl">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-120" data-mp="3nhfxpx7wfom6">
                  🌿 PROTOCOLO REENCUENTRO EN CALMA™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-121" data-mp="j1wn6v1d13jz">
                  3 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-122" data-mp="o22fmdfgeu34">
                  Tu protocolo completo en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-123" data-mp="e8bwzp60ddvc">
                <p className="text-xs uppercase tracking-wider text-slate-500" data-id="element-124" data-mp="11z7k48zirkw9">
                  Precio original
                </p>
                <p className="text-slate-500 line-through" data-id="element-125" data-mp="16s0q106q4z9x">$65.000 ARS</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-brand-light/70" data-id="element-126" data-mp="3f7sa5uaju1t7">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-127" data-mp="3aaig21c7t1z1">$19.990</p>
                <p className="text-xs text-slate-400" data-id="element-128" data-mp="359mazkg4n9s1">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-129" data-mp="31a3r8s01l4qs">
            🧠 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}